import { render, staticRenderFns } from "./NoWordsDisplay.vue?vue&type=template&id=c6858446&scoped=true&"
import script from "./NoWordsDisplay.vue?vue&type=script&lang=js&"
export * from "./NoWordsDisplay.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/pc/vocabulary.css?vue&type=style&index=0&id=c6858446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6858446",
  null
  
)

export default component.exports